"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionEvents, _actionProperties;

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

var _get_cookie = require("../helpers/get_cookie");

var _get_cookie2 = _interopRequireDefault(_get_cookie);

var _metrics = require("../legacy/helpers/metrics");

var _metrics2 = _interopRequireDefault(_metrics);

var _isFunction = require("lodash/isFunction");

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /**
                                                                                                                                                                                                                   * Report firing of specific actions to analytics endpoint.
                                                                                                                                                                                                                   */

global.ga = global.ga || function () {};
var Metrics = new _metrics2.default();

// Map action type to event name
var actionEvents = (_actionEvents = {}, _defineProperty(_actionEvents, actionTypes.DOWNLOAD_COMPLETE_SUCCESS, Metrics.download), _defineProperty(_actionEvents, actionTypes.EXPERIMENTS_SET, Metrics.set_experiments_dimension), _defineProperty(_actionEvents, actionTypes.GET_CURRENT_USER_SUCCESS, Metrics.set_user_dimension), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_COMMIT_ATTRIBUTION, Metrics.select_attribution), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_NO_PREMIUM_FEATURES, Metrics.upsell_result.bind(null, "rejected")), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_UPSELL, Metrics.upsell_result.bind(null, "accepted")), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_PURCHASE_SUCCESS, Metrics.download_flow_purchase_success), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_PURCHASE_FAILURE, Metrics.download_flow_purchase_failure), _defineProperty(_actionEvents, actionTypes.SET_ICON_COLOR_PALETTE, Metrics.download_flow_color_select), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_START_FAILURE, Metrics.download_failed), _defineProperty(_actionEvents, actionTypes.DOWNLOAD_COMPLETE_FAILURE, Metrics.download_failed), _actionEvents);

// Attributes to copy from action object to event properties object
var actionProperties = (_actionProperties = {}, _defineProperty(_actionProperties, actionTypes.DOWNLOAD_COMPLETE_SUCCESS, ["downloadType", "fileType", "icon"]), _defineProperty(_actionProperties, actionTypes.EXPERIMENTS_SET, ["experiments"]), _defineProperty(_actionProperties, actionTypes.GET_CURRENT_USER_SUCCESS, function (action) {
    return [action.response];
}), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_COMMIT_ATTRIBUTION, function (action, store) {
    var _store$getState = store.getState(),
        download = _store$getState.download;

    return [download.attributionType];
}), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_COMMIT_LICENSE, function (action, store) {
    var _store$getState2 = store.getState(),
        download = _store$getState2.download;

    return [download.license];
}), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_PURCHASE_SUCCESS, function (action, store) {
    var _store$getState3 = store.getState(),
        stripe = _store$getState3.stripe;

    return [stripe.currentPurchase];
}), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_PURCHASE_FAILURE, function (action, store) {
    var _store$getState4 = store.getState(),
        stripe = _store$getState4.stripe,
        user = _store$getState4.user;

    return [user.id, stripe.currentPurchase];
}), _defineProperty(_actionProperties, actionTypes.SET_ICON_COLOR_PALETTE, function (action, store) {
    var _store$getState5 = store.getState(),
        download = _store$getState5.download;

    return [download, action.color && action.color.selectedColor && action.color.selectedColor.hex];
}), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_START_FAILURE, ["downloadType", "icon"]), _defineProperty(_actionProperties, actionTypes.DOWNLOAD_COMPLETE_FAILURE, ["downloadType", "icon"]), _actionProperties);

var analytics = function analytics(store) {
    return function (next) {
        return function (action) {
            if (!action) {
                return next(action);
            }

            var eventName = actionEvents[action.type];

            if (!eventName) return next(action);

            var eventProperties = actionProperties[action.type],
                properties = [];

            if (eventProperties) {
                if ((0, _isFunction2.default)(eventProperties)) {
                    properties = eventProperties(action, store);
                } else {
                    eventProperties.forEach(function (prop) {
                        properties.push(action[prop]);
                    });
                }
            }

            if ((0, _isFunction2.default)(eventName)) {
                eventName.apply(null, properties);
            }

            return next(action);
        };
    };
};

exports.default = analytics;